import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the click of a sidebar navigation item',
  name: 'clicked_sidebar_navigation_item',
  params: [
    {
      description: 'The ID of the API key',
      name: 'sidebar_navigation_item_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
